import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { RacequbeLogo } from './RacequbeLogo';

const AUTH_PATHS = ['/login', '/register', '/reset-password', '/'];

export const PublicHeader: React.FC = () => {
  const location = useLocation();
  const isAuthPage = AUTH_PATHS.includes(location.pathname);

  return (
    <header
      className="sticky top-0 z-50 bg-black/95 backdrop-blur-sm border-b-2 border-transparent"
      style={{ borderImage: 'linear-gradient(to right, hsl(var(--brand-primary)), hsl(var(--brand-secondary))) 1' }}
      role="banner"
    >
      <div className="max-w-4xl mx-auto px-6 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center" aria-label="raceqube home">
          <RacequbeLogo className="h-10 w-auto" />
        </Link>

        {!isAuthPage && (
          <nav aria-label="Public navigation">
            <ul className="flex items-center gap-6">
              <li>
                <Link
                  to="/login"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Login
                </Link>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};
